import {WorkOrder} from '../ViewModel/WorkOrderViewModel'
export class AssetWorkOrderViewModel{
    AssetWorkOrderID: number;
    AssetNo: string;
    AssetDesc: string;
    workOrder: WorkOrder[] = [];
}
